import { useCallback } from 'react';
import { clampMonth, currentMonth, flagParam, periodParam, projectParam, shiftMonth } from '../utils/urlParams';
import { useUrlState } from './useUrlState';

// The month and the project a page is showing, kept in the address as ?period=2026-09&project_key=SRL
// (the names the links from Compliance and the Dashboard already use). This month and "all projects"
// are left out of the address, so /effort always means "this month, every project". A month in the
// future is read as this month.
export function usePeriodParams() {
  const { params, update } = useUrlState();
  const current = currentMonth();
  const period = clampMonth(periodParam(params), current);

  const setPeriod = useCallback(
    (next: string) => update({ period: next >= current ? null : next }),
    [update, current]
  );
  const shift = useCallback((delta: number) => setPeriod(shiftMonth(period, delta)), [setPeriod, period]);
  const setProjectKey = useCallback((key: string | null) => update({ project_key: key }), [update]);
  /** "Only mine": for the people the checks are about; an admin has no such box. */
  const setMine = useCallback((on: boolean) => update({ mine: on ? '1' : null }), [update]);

  return {
    period,
    current,
    isCurrent: period === current,
    setPeriod,
    shift,
    projectKey: projectParam(params),
    setProjectKey,
    mine: flagParam(params, 'mine'),
    setMine,
    params,
    update,
  };
}
